import {Fill, Stroke, Style} from 'ol/style';
import {ProductType} from "../model/product";

export const titleState = 'Bundesland';
export const titleDistrict = 'Bezirksregierungen';
export const titleCounty = 'Kreise/kreisfreie Städte';
export const titleKommunen = 'Kommunen';
export const titleGemarkungenFluren = 'Gemarkungen/Fluren';
export const textChooseTimespan = 'Bitte wählen Sie einen Zeitraum';
export const textValidTimespan = 'Der gewählte Zeitraum ist valide';
export const textInvalidTimespanRange = 'Zeitraum nicht valide: Der Zeitraum muss mindestens 6 Monate betragen';
export const textInvalidTimespanWinterMonth = 'Zeitraum nicht valide: Es darf nur ein Sperrmonat (Nov, Dez, Jan, Feb, Mrz) enthalten sein';
export const textUploadPortal = 'Nachdem hochladen der optionalen Daten erhalten Sie eine Upload-ID';
export const errorMsgVertices = 'Nur Geometrien mit weniger als 10.000 Stützpunkten sind zulässig.';
export const errorMsgGeomType = 'Nur Geometrien vom Typ Polygon oder Multipolygon sind zulässig.';
export const errorMsgShpFile = 'Nur .shp oder .zip Dateien sind zulässig.';
export const errorMsgNoFile = 'Es wurde keine Datei ausgewählt.';

export const searchFlurUrl = 'https://www.gis-rest.nrw.de/flurstuecksuche/lookup';

export const layerStyle = new Style({
  fill: new Fill({
    color: [0, 123, 255, 0.35],
  }),
  stroke: new Stroke({
    color: [0, 123, 255, 0.85],
    width: 3
  })
});

export const products: ProductType[] = [{
  id: 'LB',
  name: 'Erstableitung Landbedeckung'
}, {
  id: 'LB_NRW',
  name: 'Erstableitung Landbedeckung (nur NRW)'
}, {
  id: 'LB_V_ALKIS',
  name: 'Erstableitung Landbedeckung + Veränderungshinweissuche ALKIS (nur NRW)'
}];

export const extents = {
  brd: [605060.50, 5942048.07, 1722433.90, 7425907.02],
  nrw: [604748.09, 6455239.34, 1101445.74, 6946138.44]
};

export const centers = {
  brd: [10.45, 51.16],
  nrw: [7.663, 51.43]
}


